// функции для верстки

export const formatPrice = price => {
    return "number" === typeof(price) ? new Intl.NumberFormat('ru-RU').format(price) : '???'
}

export const numWord = (value, words = ['день', 'дня', 'дней'], skipvalue=false) => {  
    const absValue = Math.abs(value);
    const lastTwoDigits = absValue % 100;
    const lastDigit = lastTwoDigits % 10;

    const val = skipvalue ? '' : `${value} `;
    
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return `${val}${words[2]}`;
    }
    
    if (lastDigit >= 2 && lastDigit <= 4) {
        return `${val}${words[1]}`;
    }
    
    if (lastDigit === 1) {
        return `${val}${words[0]}`;
    }
    
    return `${val}${words[2]}`;
}

export const HaveNExcursion = value => {
    const absValue = Math.abs(value)
    let found = numWord( value, ['экскурсия', 'экскурсии на выбор', 'экскурсии на выбор'], true )
    return `${value} ${found}`
}

export const humanizeDuration = str => {
  // ожидаем формат "HH:MM:SS"
  const [h, m, s] = (str || '').split(':').map(Number)

  const parts = []

  if (h) {
    parts.push(h + ' ч');
  }

  if (m) {
    parts.push(m + ' мин');
  }

  let ret = parts.length ? parts.join(' ') : '-- ч -- мин'
  return ret
}


export const HaveFoundCruise = value => {
    const absValue = Math.abs(value)
    let found = numWord( value, ['Найден', 'Найдено', 'Найдено'], true )
    let num = numWord( value, ['круиз', 'круиза', 'круизов'] )
    return `${found} ${num}`
}
export const HaveLeftCabin = value => {
    const absValue = Math.abs(value)
    let found = numWord( value, ['Свободна', 'Свободно', 'Свободно'], true )
    let num = numWord( value, ['каюта', 'каюты', 'кают'] )
    return `${found} ${num}`
}
export const HaveChoosedCabin = value => {
    const absValue = Math.abs(value)
    let found = numWord( value, ['Выбрана', 'Выбрано', 'Выбрано'], true )
    let num = numWord( value, ['каюта', 'каюты', 'кают'] )
    return `${found} ${num}`
}


export {fetch_save} 

function fetch_save({resolve:solve, reject:ject, wait:w}) {// лексическая функция, не важно где используют
    let ok = solve ? true : false
    let wait = solve || ject ? false : w
    let resolve = solve ? solve : null
    let reject = ject ? ject : null

    return {
        ok, wait, resolve , reject
    }
}


export const pauze = ms => new Promise(resolve => setTimeout(resolve, ms))


export const debounce = (callback, wait) => {
    let timeoutId = null

    return (...args) => {
        window.clearTimeout(timeoutId)

        timeoutId = window.setTimeout(() => {
          callback.apply(null, args)
        }, wait)
    }
}

export const debounceOrIm = (callback, wait) => {
    let timeoutId = null

    return (tryNow=false) => {
        window.clearTimeout(timeoutId)

        if (tryNow) {
            callback.apply(null)
        } else {
            timeoutId = window.setTimeout(() => {
              callback.apply(null)
            }, wait)
        }
    }
}
